import { ReviewerOption } from './PatientWorkQueue.types';

export enum ColumnHeaders {
  ACCOUNT_NUMBER = 'Account #',
  ADMISSION_ID = 'Admission Id',
  ASSIGNMENT = 'Assignment',
  ATTENDING_PHYSICIAN = 'Attending Physician',
  AUTO_ESCALATION_REASON = 'Auto-Escalation Reason',
  CHIEF_COMPLAINT = 'Chief Complaint',
  CURRENT_ASSIGNMENT = 'Current Assignment',
  CURRENT_CLS = 'Current CLS',
  DOB = 'DOB',
  ESCALATION_DATE = 'Escalation Date',
  FACILITY = 'Facility',
  LAST_PA_REVIEW = 'Last PA Review',
  LOCATION = 'Location',
  MAX_CLS = 'Max CLS',
  MEL = 'MeL',
  MRN = 'MRN',
  P2P_REVIEW_DUE = 'P2P Review Due',
  P2P_SCHEDULED_DATE_TIME = 'P2P Scheduled Date/Time',
  PA_STATUS = 'PA Status',
  PATIENT = 'Patient',
  PAYER_PRIMARY = 'Primary Payer',
  PEDIATRIC_INDICATOR = 'Pediatric Indicator',
  PRESENTATION_DATE = 'Presentation Date',
  PRIORITY = 'Priority',
  REVIEW_DUE = 'Review Due',
  REVIEW_TYPE = 'Review Type',
  ROOM_NUMBER = 'Room #',
  SECOND_LEVEL_REASON = '2nd Level Reason',
  SECONDARY_PAYER = 'Secondary Payer',
  STATUS = 'Status',
  TAT = 'TAT',
  TOTAL_LOS = 'Total LOS',
}

export enum ColumnField {
  ADMISSION_DATE = 'admission_date',
  ADMISSION_ID = 'admission_id',
  ADMISSION_STATUS = 'admission_status',
  ASSIGNED_USERNAME = 'assigned_username',
  ATTENDING_PHYSICIAN = 'attending_physician',
  AUTO_ESCALATION_REASON_DESCRIPTION = 'auto_escalation_reason_description',
  BIRTH_DATE = 'birth_date',
  CHIEF_COMPLAINT = 'chief_complaint',
  CLIENT_ESCALATION_DATE = 'client_escalation_date',
  CURRENT_CLS = 'current_cls',
  ENTITY_NAME = 'entity_name',
  FINANCIAL_CLASS = 'financial_class',
  HIGH_PRIORITY_YN = 'high_priority_yn',
  IS_PENDING = 'is_pending',
  LAST_PA_REVIEW_USER = 'last_pa_review_user',
  MAX_CLS = 'max_cls',
  MEL = 'mel',
  MINUTES_UNTIL_DEADLINE = 'minutes_until_deadline',
  MRN = 'mrn',
  PATIENT_NAME = 'patient_name',
  PEDIATRIC_INDICATOR = 'pediatric_indicator',
  POINT_OF_CARE_DESCRIPTION = 'point_of_care_description',
  REVIEW_DUE_DATE = 'review_due_date',
  REVIEW_TYPE = 'review_type',
  ROOM_NBR = 'room_nbr',
  SCHEDULED_DATE_TIME = 'scheduled_date_time',
  SECOND_LEVEL_REASON_TEXT = 'second_level_reason_text',
  SECONDARY_FINANCIAL_CLASS = 'secondary_financial_class',
  TLOS = 'tlos',
  TOTAL_LENGTH_OF_STAY = 'total_length_of_stay',
  VISIT_NBR = 'visit_nbr',
}

export const PAGINATION_PAGE_SIZE = 100;
export const PAGINATION_AVAILABLE_PAGE_SIZES = [5, 10, 20, 25, 50, 100];

export const DATE_TIME_FORMAT = 'MM/DD/YYYY HH:mm';
export const DATE_FORMAT = 'MM/DD/YYYY';
export const GMT_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
export const DATE_TIME_AM_PM_FORMAT = 'MM/DD/YYYY h:mm a';

export const END_STAGE_RENAL_DISEASE_INDICATOR_CLASS =
  'end-stage-renal-disease-indicator';
export const CHILD_INDICATOR_CLASS = 'child-indicator';
export const REVIEW_TYPE_EDITABLE_CLASS = 'review-type-editable';
export const ASSIGNMENT_EDITABLE_CLASS = 'assignment-editable';
export const PEDIATRIC_INDICATOR_CLASS = 'pediatric-indicator';

export const INPATIENT = 'Inpatient';
export const DISCHARGED_AS_INPT = 'Discharged as INPT';

export const LENGTH_OF_STAY_TIME_IN_HOURS = 'H';
export const LENGTH_OF_STAY_TIME_IN_DAYS = 'D';

export const TWENTY_FOUR = 24;

export const OBSERVATION = 'Observation';
export const OBSERVATION_PLUS = 'ObservationPlus';
export const PUM_INPATIENT = 'PUM Inpatient';
export const PUM_OBSERVATION = 'PUM Observation';
export const INPATIENT_PLUS = 'InpatientPlus';

export const LOADING_LABEL = 'Loading';

export const STATUS_DETERMINATION = 'Status Determination';
export const INITIAL = 'Initial';
export const PEER_TO_PEER = 'Peer-to-Peer';
export const ESCALATE_FOR_XSOLIS_PEER_TO_PEER =
  'Escalate for XSOLIS Peer-to-Peer';
export const ESCALATE_FOR_PEER_TO_PEER = 'Escalate for Peer-to-Peer';
export const APPEAL_RETROSPECTIVE = 'Appeal/Retrospective';
export const MANUAL = 'Manual';
export const PHYSICIAN_ADVISOR = 'Physician Advisor';
export const UNASSIGNED = 'Unassigned';
export const ASSIGNED_TO_ANOTHER_TEAM = 'Assigned To Another Team';
export const UNASSIGN = 'UNASSIGN';
export const ASSIGN_TO_ME = 'ASSIGN TO ME';
export const REMOVE_PATIENT_ENCOUNTER = 'Remove Patient Encounter';
export const MY_ASSIGNMENTS = 'My Assignments';

export const ASSIGN_TO_ME_OPTION: ReviewerOption = {
  key: ASSIGN_TO_ME,
  text: ASSIGN_TO_ME,
  value: ASSIGN_TO_ME,
};

export const UNASSIGNED_OPTION: ReviewerOption = {
  key: UNASSIGNED,
  text: UNASSIGNED,
  value: UNASSIGNED,
};

export const REMOVE_PATIENT_ENCOUNTER_OPTION: ReviewerOption = {
  key: REMOVE_PATIENT_ENCOUNTER,
  text: REMOVE_PATIENT_ENCOUNTER,
  value: REMOVE_PATIENT_ENCOUNTER,
};

export const TAT_CALCULATION_INTERVAL = 60000; // 1 minute

export enum PA_STATUSES {
  EMPTY = 'EMPTY',
  PA_TO_SCHEDULE = 'PATS',
  PENDING = 'P',
  SCHEDULED = 'S',
}

export enum PA_STATUSES_FILTERS {
  EMPTY = 'Blank',
  PA_TO_SCHEDULE = 'PA to schedule',
  PENDING = 'Pending',
  SCHEDULED = 'Scheduled',
}

export enum LABELS_COLORS {
  GREEN = 'green',
  ORANGE = 'orange',
  YELLOW = 'yellow',
}

export const LABELS_STYLES = {
  fontSize: '14px',
  textAlign: 'center',
  width: '100%',
};

export const STATUS_LABEL_POPUP_CONTENT =
  'Physician Advisor to Schedule Peer-To-Peer';

export const PEDIATRIC_AGE = 18;

export enum PediatricIndicatorValues {
  OVER_18 = 'Over 18',
  UNDER_18 = 'Under 18',
}

export const INVALID_DATE = 'Invalid date';

export const RECENTLY_VIEWED_PATIENTS = 'Recently Viewed Patients';
export const WORK_QUEUE_LABEL = 'Work Queue';
export const MY_ASSIGNMENTS_LABEL = 'MY ASSIGNMENTS';
export const MANUAL_LABEL = 'MANUAL';
export const APPEAL_RETRO_LABEL = 'APPEAL / RETROSPECTIVE';
export const STATUS_DETERMINATION_LABEL = 'STATUS DETERMINATION';
export const PEER_TO_PEER_LABEL = 'PEER-TO-PEER';
export const CLEAR_FILTERS_LABEL = 'CLEAR FILTERS';
export const MESSAGE_CENTER_LABEL = 'MESSAGE CENTER';
export const RESET_COLUMNS_LABEL = 'RESET COLUMNS';

export const FILTERS = {
  APPEAL_RETROSPECTIVE,
  MANUAL,
  MY_ASSIGNMENTS,
  PEER_TO_PEER,
  STATUS_DETERMINATION,
} as const;

export const ERROR_RETRIEVING_QUEUE_DATA = 'ERROR RETRIEVING QUEUE DATA';

export const COLUMN_ORDER = 'columnOrder';
export const COLUMN_SIZING = 'columnSizing';
export const COLUMN_SORT = 'sort';
export const COLUMN_FILTER = 'filter';
export const COLUMN_PINNING = 'columnPinning';
export const COLUMN_VISIBILITY = 'columnVisibility';

export const COLUMN_STATES_FOR_BE_SAVING = [
  COLUMN_ORDER,
  COLUMN_SIZING,
  COLUMN_PINNING,
  COLUMN_VISIBILITY,
];

export const COLUMN_STATES_FOR_LOCAL_SAVING = [COLUMN_SORT, COLUMN_FILTER];

export const GRID_SETTINGS_SAVE_DELAY = 500;
export const PATIENT_WORK_QUEUE_FILTER_BUTTONS_STATE = 'PWQFilterButtonsState';
export const PATIENT_WORK_QUEUE_SORTING_FILTERS_STATE =
  'PWQSortingFiltersState';

export enum ColumnMenuItems {
  PIN_SUBMENU = 'pinSubMenu',
}

export enum SecondLevelReason {
  EXTENDED_MEDICARE_OUTLIER_INPATIENT_CASE = 'Extended Medicare Outlier Inpatient Case',
  EXTENDED_OBS_STAY = 'Extended OBS stay',
  INPATIENT_DOCUMENTATION_NOT_SUPPORT_MEDICAL_NECESSITY = 'Inpatient, documentation does not support medical necessity',
  INPATIENT_ONLY_PROCEDURE_PATIENT_IN_OBS_OR_NO_ORDER_FOR_INPT_ADMISSION = 'Inpatient Only Procedure/Patient in OBS or no order for INPT admission',
  INPATIENT_WITH_LESS_THAN_2_MIDNIGHTS = 'Inpatient with less than 2 Midnights',
  OBS_1_MN_NO_DISCHARGE_ORDER = 'OBS 1 MN, no discharge order',
  OTHER_ENTER_COMMENT = 'Other (enter comment)',
  OUTPATIENT_IN_A_BED = 'Outpatient in a bed',
  PEER_TO_PEER_CONSIDERATION = 'Peer-to-Peer consideration',
  POSSIBLE_CC44 = 'Possible CC44',
  RETRO_MEDICAID_INPT_SHORT_STAY_REVIEW = 'Retro Medicaid INPT Short Stay review',
  RETRO_REVIEW_MEDICARE_IP_WITH_LESS_THAN_2_MN_STAY = 'Retro Review, Medicare IP with <2 MN stay',
  RETRO_REVIEW_PAYER_REQUESTS_OBS = 'Retro Review, Payer requests OBS',
  STATUS_DETERMINATION = 'Status Determination',
}

export const BLANK = 'Blank';

export enum ScheduleOptionSelectedOptions {
  PA_TO_SCHEDULE_PEER_TO_PEER = 'PA to Schedule Peer-To-Peer',
  PEER_TO_PEER_SCHEDULED = 'Peer-To-Peer Scheduled',
  PEER_TO_PEER_SCHEDULED_BY_PA = 'Peer-To-Peer Scheduled By PA',
}

export enum REVIEW_STATUS {
  COMPLETED = 'Completed',
  IN_PROGRESS = 'In Progress',
  PENDING = 'Pending',
}

export enum AdmissionStatus {
  DISCHARGED_AS_ED = 'DISCHARGED AS ED',
  DISCHARGED_AS_INPT = 'DISCHARGED AS INPT',
  DISCHARGED_AS_OBS = 'DISCHARGED AS OBS',
  DISCHARGED_AS_OUTPT = 'DISCHARGED AS OUTPT',
  EMERGENCY_ROOM = 'EMERGENCY_ROOM',
  INPATIENT = 'INPATIENT',
  OBSERVATION = 'OBSERVATION',
  OUTPATIENT = 'OUTPATIENT',
  PREADMIT = 'PREADMIT',
}
